var map = {
	"./actions-en.png": 30389,
	"./actions-es.png": 35088,
	"./additional-data-alert-en.png": 33485,
	"./additional-data-alert-es.png": 65272,
	"./additional-data-cif-en.png": 30017,
	"./additional-data-cif-es.png": 85572,
	"./additional-data-days-after-availability-en.png": 5759,
	"./additional-data-days-after-availability-es.png": 18282,
	"./additional-data-days-after-receival-en.png": 54635,
	"./additional-data-days-after-receival-es.png": 76542,
	"./additional-data-email-en.png": 97495,
	"./additional-data-email-es.png": 25490,
	"./additional-data-filter-en.png": 10993,
	"./additional-data-filter-es.png": 86708,
	"./additional-data-http-en.png": 32223,
	"./additional-data-http-es.png": 97770,
	"./additional-data-observation-en.png": 45017,
	"./additional-data-observation-es.png": 34828,
	"./additional-data-operator-en.png": 32607,
	"./additional-data-operator-es.png": 45130,
	"./additional-data-word-en.png": 24335,
	"./additional-data-word-es.png": 91034,
	"./additional-history-en.png": 84928,
	"./additional-history-es.png": 61733,
	"./after-date-en.png": 62805,
	"./after-date-es.png": 83856,
	"./assign-responsible-example-en.png": 40899,
	"./assign-responsible-example-es.png": 82918,
	"./at-history-en.png": 15484,
	"./at-history-es.png": 39273,
	"./at-icon-en.png": 95211,
	"./at-icon-es.png": 40414,
	"./before-date-en.png": 36896,
	"./before-date-es.png": 13701,
	"./clone-button-en.png": 11064,
	"./clone-button-es.png": 13562,
	"./conditions-and-en.png": 36066,
	"./conditions-and-es.png": 50439,
	"./conditions-en.png": 52998,
	"./conditions-es.png": 22371,
	"./create-at-button-en.png": 97109,
	"./create-at-button-es.png": 49776,
	"./create-at-dialog-en.png": 87749,
	"./create-at-dialog-es.png": 69824,
	"./delete-at-en.png": 77905,
	"./delete-at-es.png": 99700,
	"./delete-at-msg-en.png": 55625,
	"./delete-at-msg-es.png": 59516,
	"./dynamic-text-en.png": 20343,
	"./dynamic-text-es.png": 77906,
	"./edit-at-en.png": 25772,
	"./edit-at-es.png": 39513,
	"./edit-task-button-en.png": 65561,
	"./edit-task-button-es.png": 68172,
	"./example-1-en.png": 84722,
	"./example-1-es.png": 56727,
	"./example-2-en.png": 93159,
	"./example-2-es.png": 78786,
	"./example-3-en.png": 42868,
	"./example-3-es.png": 4721,
	"./example-4-en.png": 26121,
	"./example-4-es.png": 95836,
	"./example-5-en.png": 50030,
	"./example-5-es.png": 67995,
	"./history-button-en.png": 67843,
	"./history-button-es.png": 98470,
	"./pause-en.png": 73028,
	"./pause-es.png": 99073,
	"./temporal-en.png": 4234,
	"./temporal-es.png": 8063
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39781;